import {
	CruiseCardLocationListBase,
	CruiseCardLocationListItem,
	CruiseCardLocationListItemsContainer,
	CruiseCardLocationListTitle,
} from './CruiseCardLocationList.styles';
import { CruiseCardLocationListProps } from './CruiseCardLocationList.types';

function CruiseCardLocationList({ title, locations, variant, packageId }: CruiseCardLocationListProps) {
	return locations.length > 0 ? (
		<CruiseCardLocationListBase variant={variant} data-testid={`cruise-ports-label-${packageId}`}>
			<CruiseCardLocationListTitle>{title}:</CruiseCardLocationListTitle>
			<CruiseCardLocationListItemsContainer>
				{locations.map((location, index) => {
					const key = `cruise-card-location-list-item-${packageId}-${index}`;
					return <CruiseCardLocationListItem key={key}>{location.name}</CruiseCardLocationListItem>;
				})}
			</CruiseCardLocationListItemsContainer>
		</CruiseCardLocationListBase>
	) : (
		<></>
	);
}

export default CruiseCardLocationList;
